import { Star } from "lucide-react";
import { Reveal } from "./Reveal";

const TESTIMONIALS = [
  {
    initials: "MT",
    name: "Mariana T.",
    role: "São Paulo, SP",
    quote: "Li em dois dias. O capítulo sobre a dicotomia do controle mudou minha relação com o trabalho — parei de carregar problemas que nunca foram meus.",
  },
  {
    initials: "RA",
    name: "Rafael A.",
    role: "Belo Horizonte, MG",
    quote: "Já tinha tentado ler Sêneca e desisti. O LF traduz tudo para situações reais: trânsito, chefe difícil, crise no casamento. Direto ao ponto.",
  },
  {
    initials: "CB",
    name: "Camila B.",
    role: "Curitiba, PR",
    quote: "O ritual do diário estoico virou parte da minha manhã. Dez minutos que valem mais que anos de terapia tentando controlar o incontrolável.",
  },
];

export const Testimonials = () => (
  <section data-testid="testimonials-section" className="py-20 md:py-28">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal className="max-w-3xl">
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#d4af37]">Quem já leu</p>
        <h2 className="mt-4 font-serif text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#f4f1ea]">
          Mentes que já estão <span className="text-gold-gradient italic">mais serenas</span>
        </h2>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={t.name} delay={0.1 * i}>
            <figure
              data-testid={`testimonial-card-${i + 1}`}
              className="h-full rounded-2xl border border-[#d4af37]/15 bg-[#14141a] p-8 flex flex-col transition-colors duration-500 hover:border-[#d4af37]/40"
            >
              <div className="flex gap-1">
                {[...Array(5)].map((_, s) => (
                  <Star key={s} className="w-4 h-4 fill-[#d4af37] text-[#d4af37]" />
                ))}
              </div>
              <blockquote className="mt-6 flex-1 text-sm sm:text-base text-zinc-300 leading-relaxed">
                "{t.quote}"
              </blockquote>
              <figcaption className="mt-7 flex items-center gap-4">
                <span className="w-11 h-11 rounded-full bg-[#1f1a08] border border-[#d4af37]/40 flex items-center justify-center font-serif font-bold text-[#f5d77f]">
                  {t.initials}
                </span>
                <span>
                  <span className="block text-sm font-bold text-[#f4f1ea]">{t.name}</span>
                  <span className="block text-xs text-zinc-500 mt-0.5">{t.role}</span>
                </span>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
